<template>
    <div style="padding: 30px;">
        <div style="margin-bottom:20px;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Asn Order</el-breadcrumb-item>
                <el-breadcrumb-item>Modify</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="">
            <el-steps :active="active" finish-status="success" align-center>
                <el-step title="Fill in the number of warehousing"></el-step>
                <el-step title="Fill in the warehousing information"></el-step>
                <el-step title="Choose value-added services"></el-step>
                <el-step title="Waiting for warehouse storage"></el-step>
            </el-steps>
        </div>
        <!-- 四步 -->
        <div class="stepsTab" v-show="active === 1">
            <div style="padding: 15px 0;">
                <!-- 取货方式 -->
                <span>Pre-package method:</span>
                <el-radio-group v-model="form.resource" @change="packaging">
                    <el-radio :label="1">Suntek packaging</el-radio>
                    <!-- <el-radio :label="2">Packing yourself</el-radio> -->
                </el-radio-group>
            </div>
            <el-table
                ref="multipleTable"
                :data="tableData"
                border
                style="width: 100%"
                :row-class-name="tableRowClassName"
            >
                <!-- <el-table-column type="selection"  :reserve-selection="true" :selectable="selectable" width="60" fixed="left"></el-table-column> -->
                <el-table-column label="Image" prop="image">
                    <template slot-scope="scope">
                        <img
                            :src="scope.row.image"
                            min-width="70"
                            height="70"
                        />
                    </template>
                </el-table-column>
                <el-table-column label="SKU" prop="sku"></el-table-column>
                <el-table-column
                    label="English name"
                    prop="title"
                ></el-table-column>
                <el-table-column label="Number of warehousing" prop="quantity">
                    <template slot-scope="scope">
                        <!-- @blur="keydownproducts" 失焦校验 -->
                        <el-input
                            type="number"
                            v-model.Number="scope.row.quantity"
                            min="1"
                        ></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="remove" prop="del" align="center">
                    <template slot-scope="scope">
                        <i
                            class="el-icon-delete delBtn"
                            title="delete"
                            @click="deleteSku(scope.row)"
                        ></i>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="stepsTab" v-show="active === 2">
            <el-form ref="twoform" :model="twoform" label-width="280px" @submit.native.prevent> 
                <el-form-item label="Reference No">
                    <el-input
                        v-model="twoform.referenceNo"
                        style="width:217px"
                    ></el-input>
                </el-form-item>
                <el-form-item label=" Shenzhen warehouse address :">{{
                    twoform.warehouseAddressEn
                }}</el-form-item>

                <el-form-item label="ANS priority :">
                    <el-radio-group v-model="twoform.asnLevel">
                        <el-radio label="0">Roboto-Regular</el-radio>
                        <el-radio label="1">Urgent</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Unloading party :">
                    <el-radio-group v-model="twoform.unLoading">
                        <el-radio label="0">Unloading yourself</el-radio>
                        <el-radio label="1">Suntek unloading</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Arrival method :">
                    <el-radio-group
                        v-model="twoform.receivingWay"
                        @change="delivery"
                    >
                        <el-radio label="1">Delivery to your door</el-radio>
                        <el-radio label="2">Third party delivery</el-radio>
                        <el-radio label="3"
                            >Third party delivery, no waybill number</el-radio
                        >
                    </el-radio-group>
                </el-form-item>
                <div v-if="twoform.receivingWay==='2'">
                    <template v-for="item1 in twoform.carriers">
                        <el-collapse
                            :key="item1.index"
                            style="position: relative;"
                            :accordion=true
                            v-model="activeNames"
                        >
                            <el-collapse-item name="1">
                                <template slot="title">
                                    <div
                                        style="padding-left: 10px;border-left: 2px solid #8989ba; height: 30px;line-height: 30px;"
                                    >
                                        Carrier
                                    </div>
                                    <!-- <i
                                        class="el-icon-delete"
                                        style="position: absolute;color: red;right: 30px;font-size: 16px;"
                                        @click.stop="deletecarrier(item1)"
                                    ></i> -->
                                </template>
                                <el-form-item
                                    label="Carrier name :"
                                    :key="item1.index"
                                >
                                    <el-select
                                        v-model="item1.carrier"
                                        placeholder="Logistics company name"   
                                    >
                                        <el-option
                                            v-for="(item,
                                            index1) in carriername"
                                            :key="item"
                                            :label="item"
                                            :value="index1"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="tracking number" :key="item1.index">
                                    <el-input v-model="item1.trackingNumber" style="width:217px"></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="Contact :"
                                    :key="item1.index"
                                >
                                    <el-input
                                        v-model="item1.contactPerson"
                                        style="width:217px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="Contact number :"
                                    :key="item1.index"
                                >
                                    <el-input
                                        v-model="item1.contactNumber"
                                        style="width:217px"
                                    ></el-input>
                                </el-form-item>
                                
                                <el-form-item
                                    label="Expected arrival time :"
                                    :key="item1.index"
                                >
                                    <!-- <el-input v-model="item1.arrivaltime"  type="datetime" style="width:217px"></el-input> -->
                                    <el-date-picker
                                        v-model="item1.estimatedDeliveryDate"
                                        :picker-options="pickerOptions"
                                        type="date"
                                        placeholder="Choose the date and time"
                                        value-format="yyyy-MM-dd"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-collapse-item>
                        </el-collapse>
                    </template>
                </div>
                <div
                    v-if="onejs"
                    style="padding: 10px; text-align: center;color: #f36a21;font-size: 16px;"
                >
                    Logistics company name !
                </div>
            </el-form>
        </div>
        <div class="stepsTab" v-show="active === 3">
            <div style="padding: 15px 0;">
                <el-button
                    @click="addservices"
                    style="background:#8989ba;color:#fff;outline: none"
                    >Add value-added services</el-button
                >
            </div>

            <el-table
                :data="tableData3"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                class="expand"
                :default-expand-all="true"
            >
                <el-table-column type="expand" >
                    <template slot-scope="props">
                        <el-form
                            label-position="left"
                            inline
                            class="demo-table-expand" v-if="props.row.SPO_item.length>0" @submit.native.prevent>
                            <el-table :data="props.row.SPO_item" style="width: 100%">
                                <el-table-column prop="title" label="Value-added service name" ></el-table-column>
                                <el-table-column prop="note" label="Service request" >
                                    <template slot-scope="scope">
                                        <el-input  v-model="scope.row.note" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="operation">
                                    <template slot-scope="scope">
                                        <i
                                            class="el-icon-delete delBtn"
                                            title="delete"
                                            @click="deleteSpo(props.row.SPO_item,scope.row)"
                                        ></i>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column
                    type="selection"
                    width="60"
                    fixed="left"
                ></el-table-column>
                <el-table-column label="Image" prop="id">
                    <template slot-scope="scope">
                        <img
                            :src="scope.row.image"
                            min-width="70"
                            height="70"
                        />
                    </template>
                </el-table-column>
                <el-table-column label="SKU" prop="sku"></el-table-column>
                <el-table-column
                    label="English name"
                    prop="title"
                ></el-table-column>
                <el-table-column label="Value-added services" prop="SPO_item">
                    <template slot-scope="scope">
                        <div v-if="scope.row.SPO_item.length>0">
                            <span
                                v-for="(ingh, index2) in scope.row.SPO_item"
                                :key="index2"
                                style="margin-right:5px;"
                                >{{ ingh.title }}</span
                            >
                        </div>
                        <div v-if="scope.row.SPO_item.length==0">
                            <p @click="addSPO(scope)" style="cursor:pointer">Add value-added services</p>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="stepsTab" v-show="active === 4">
            <div class="ban" style="text-align: center;height:400px;position: relative;" >
                <div style="position: absolute;left: 0;right: 0;top: 0;bottom: 0;margin: auto;height: 100px;" >
                    <i class="el-icon-circle-check-outline" style="font-size: 97px;color: #7ec1e1;" ></i>
                    <p style="padding: 10px;">
                        Once the ANS order has been revised, the warehouse will
                        receive your goods and put them on the shelves according
                        to the ANS list.
                    </p>
                    <router-link to="/AsnOrder">
                        <a>View my ANS list</a>
                    </router-link>
                </div>
            </div>
        </div>

        <!-- 上一步 下一步 控制按钮显示 -->
        <div class="stepBtns">
            <el-button
                v-show="active === 2 || active===3"
                @click="Previous"
                style="background:#a9a9bc;color:#fff;outline: none"
                >Previous</el-button
            >
            <el-button
                v-show="active ===1 || active===2"
                @click="Next"
                style="background:#8989ba;color:#fff;outline: none"
                >Next step</el-button
            >
            <el-button v-show="active===3" @click="submitEdit('add')" style="background:#a9a9bc;color:#fff;outline: none">submit</el-button>
            <span v-show="active === 1" style="color: #b0b0b0;font-size:14px"
                >Total: {{ Total }} SKU,{{ products }} products</span
            >
            <a v-show="active === 3" @click="submitEdit('noAdd')">Skip value-added services</a>
        </div>

        <el-dialog
            title="Value-added service list"
            :visible.sync="dialogTableVisible"
            center>
            <el-table :data="gridData">
                <el-table-column width="60" fixed="left">
                    <template slot-scope="scope">
                        <el-checkbox
                            v-model="scope.row.checked"
                            @change="gridchange(scope.row)"
                        ></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column
                    property="spop_desc"
                    label="Value-added service name"
                ></el-table-column>
                <el-table-column
                    property="spop_value_l"
                    label="Service request"
                ></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogRecharge" >Recharge</el-button>
                <el-button type="info" @click="dialogTableVisible= false">Cancel</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getasndetail, asnshipping, createasn } from "../../../views/api/ans.js";
import { getspecial } from "../../api/ans";
export default {
    data() {
        // 运单号校验
        const validatorTrackNum = (rule, value, callback) => {
            if(!value){
                callback(new Error('Please enter the required fields'))
            }else if(value!==''){
                const reg = /^[A_Z0-9]{6,18}$/
                if(!reg.test(value)){
                    callback(new Error('Please enter the correct waybill number'))
                }
            }
            callback();
        }
        // 联系方式校验
        const validatorContactNum = (rule, value, callback) => {
            if(value!==''&&value!==undefine){
                const reg = /^(((\\+\\d{2}-)?0\\d{2,3}-\\d{7,8})|((\\+\\d{2}-)?(\\d{2,3}-)?([1][3,4,5,7,8][0-9]\\d{8})))$/
                if(!reg.test(value)){
                    callback(new Error('Please enter the correct contact information'))
                }
            }
            callback();
        }
        return {
            // asnStatus:'2', // 当前asn单状态（路由传参），2可以全部改，7只能改数字（要请求数字限制接口）
            gridData: [],
            Selection: [],
            hasAddService:false,
            active: 1,
            form: {
                // 取货方式
                resource: 1
            },
            dialogTableVisible: false,
            tableData: [], // step1数据  getDetails时获取
            Total: 0,
            products: 0,
            ofdelivery: true,
            onejs: false,
            carriername: [],
            add_service:true,
            asn_create_time:'2019-04-23',// asn单创建时间
            pickerOptions:{
                disabledDate: time =>{
                    return this.dealDisabledDate(time)
                }
            }, // 控制日期选择（到货时间不会早于asn单创建时间）
            twoform: {
                Reference: "",
                region: "",
                delivery: false,
                Roboto: 1,
                desc: "",
                Unloading: 1,
                carriers: [
                    {
                        carrier: "",
                        contactPerson: "",
                        contactNumber: "",
                        trackingNumber:'',
                        estimatedDeliveryDate: ""
                    }
                ]
            },
            tableData3: [],
            handleSelecti: "",
            activeNames:['1'],
            addserv:false,
            nowSku:''
            // rules:{
            //     carrier_name:[{required: true, message:'请选择快递公司',trigger:'change'}],
            //     tracking_number:[{required: true, validator: validatorTrackNum, trigger:'blur'}],
            //     contact_number:[{required: false, validator: validatorContactNum, trigger:'blur'}]
            // }
        };
    },
    created() {
        this.getDetail();
    },
    mounted() {
        asnshipping().then(response => {
            if (response.data.ask == 1) {
                this.carriername = response.data.data;       
            }
        })
        .catch(error => {
            console.log(error);
        });
        // this.getDetail();
    },
    methods: {
        checkNum(value) {
            let OK = true;
            if (value !== "") {
                let reg = /^[1-9][0-9]*$/;
                if (!reg.test(value)) {
                    OK = false;
                }
            } else {
                OK = false;
            }
            return OK;
        },
        dealDisabledDate(time){

            let startDate =this.asn_create_time;
            startDate= startDate.replace(new RegExp("-","gm"),"/");
            let startDateM = (new Date(startDate)).getTime(); //得到毫秒数
            return time.getTime() < startDateM;
           
        },
        getDetail() {
            this.tableData = [];
            this.tableData3 = [];
            getasndetail({ asn_code: this.$route.params.asn_code }).then(
                response => {
                // getasndetail({asn_code:'RA0091141030001'}).then(response => {
                    
                    // 返回的数据，如果是单条就是json，多条就是数组
                    if (response.data.ask === 1) {
                        if (Array.isArray(response.data.data.asnItem)) {
                            response.data.data.asnItem.forEach(val => {
                                const json = {
                                    image: val.imgUrl,
                                    sku: val.sku,
                                    title: val.title,
                                    quantity: val.quantity,
                                    SPO_item:[]
                                };
                                this.tableData.push(json);
                            });
                            let count = 0;
                            this.Total = this.tableData.length;
                            for (let i = 0; i < this.Total; i++) {
                                count += Number(this.tableData[i].quantity);
                            }
                            this.products = count;
                            this.tableData3 = this.tableData;
                        } else {
                            const json = {
                                image: response.data.data.asnItem.imgUrl,
                                sku: response.data.data.asnItem.sku,
                                title: response.data.data.asnItem.title,
                                quantity: response.data.data.asnItem.quantity,
                                SPO_item:[]
                            };
                            this.tableData.push(json);
                            this.Total = 1;
                            this.products = response.data.data.asnItem.quantity;
                            this.tableData3 = this.tableData;
                        }
                        // 处理第二页数据
                        if (response.data.data.asnInf) {
                            this.ofdelivery = true;
                            // receivingWay 字段需判断，第一种和第三种都返回2，要判断是不是有
                            let type = response.data.data.asnInf.receivingWay;
                            this.asn_create_time = response.data.data.asnInf.created;
                            if (type === "2") {
                                if (
                                    !response.data.data.trackingInformation
                                        .trackingNumber
                                ) {
                                    type = "3";
                                }
                            }
                            this.twoform = {
                                referenceNo: response.data.data.asnInf.referenceNo,
                                asnLevel: response.data.data.asnInf.asnLevel,
                                unLoading: response.data.data.asnInf.unLoading,
                                receivingWay: type, // 送货方式
                                warehouseAddressEn: response.data.data.asnInf.warehouseAddressEn,
                                receivingId: response.data.data.asnInf.receivingId,
                                carriers: [
                                    {
                                        carrier: "",
                                        contactPerson: "",
                                        contactNumber: "",
                                        trackingNumber:'',
                                        estimatedDeliveryDate: ""
                                    }
                                ]
                            };
                        }
                        
                        if (response.data.data.trackingInformation) {
                            //  将快递名转为下标
                            let site 
                            this.carriername.forEach((item, index) => {
                                if(item === response.data.data.trackingInformation.carrier){
                                   site = index
                                }
                            })
                            let carrierJson = {
                                carrier: site,
                                contactPerson: response.data.data.trackingInformation.contactPerson,
                                contactNumber:response.data.data.trackingInformation.contactNumber,
                                trackingNumber:response.data.data.trackingInformation.trackingNumber,
                                estimatedDeliveryDate:response.data.data.trackingInformation.estimatedDeliveryDate
                            };
                            this.twoform.carriers = [];
                            this.twoform.carriers.push(carrierJson);
                        }
                        // tableData3 处理增值服务数据
                        if(response.data.data.specialService){
                            if(Array.isArray(response.data.data.specialService)){
                                this.add_service = true;
                                let specialArr = response.data.data.specialService;
                                this.tableData3.forEach((val, index) => {
                                    let itemArr = [];
                                    specialArr.forEach((vals, indexs) => {
                                        val.spop_desc = val.title;
                                        if(val.sku === vals.sku){
                                            itemArr.push(specialArr[indexs]);
                                        }
                                    })
                                    val.SPO_item = itemArr
                                })
                            }else{
                                this.add_service = true;
                                let specialArr = [];
                                specialArr.push(response.data.data.specialService);
                                this.tableData3.forEach((val, index) => {
                                    let itemArr = [];
                                    specialArr.forEach((vals, indexs) => {
                                        val.spop_desc = val.title;
                                        if(val.sku === vals.sku){
                                            itemArr.push(specialArr[indexs]);
                                        }
                                    })
                                    val.SPO_item = itemArr
                                })

                            }

                            // if(response.data.data.specialService.length>0){
                            //     this.add_service = true;
                            //     let specialArr = response.data.data.specialService;
                            //     this.tableData3.forEach((val, index) => {
                            //         let itemArr = [];
                            //         specialArr.forEach((vals, indexs) => {
                            //             val.spop_desc = val.title;
                            //             if(val.sku === vals.sku){
                            //                 itemArr.push(specialArr[indexs]);
                            //             }
                            //         })
                            //         val.SPO_item = itemArr
                            //     })
                            // }else{
                            //     this.add_service = false;
                            // }                    
                        }else{
                            this.add_service = false;
                        }
                    }
                    console.log(this.tableData3)
                }
            );
            
        },
        packaging() {
            if (this.form.resource == 1) {
                // this.tableHead = example1;
            } else if (this.form.resource == 2) {
                // this.tableHead = example2;
            }
        },
        Next() {
            // 下一步hahah
            if (this.active > 4) {
                return;
            }
            let canNext = true;
            switch (this.active) {
                case 1:
                    this.tableData.forEach(val => {
                        if (!this.checkNum(val.quantity)) {
                            this.$message({
                                message: "Please enter the correct number",
                                type: "warning"
                            });
                            canNext = false;
                        }
                    });
                    break;
                case 2:
                    // 送货方式选2，需填写快递公司和trackNumber
                    if(this.twoform.receivingWay==='2'){
                        if(!this.twoform.carriers[0].carrier && this.twoform.carriers[0].carrier!==0){
                            this.$message({
                                message:'Please choose express delivery',
                                type:'warning'
                            });
                            canNext = false;
                            return;
                        }
                        // const reg = /^[A_Za-z0-9]{6,18}$/
                        // if(!reg.test(this.twoform.carriers[0].trackingNumber)){
                        if(!this.twoform.carriers[0].trackingNumber){
                            this.$message({
                                message:'Please enter the correct waybill number',
                                type:'warning'
                            })
                            canNext = false;
                            return
                        }
                    };
                    break;
                default:{
                    
                }
            }
            if (canNext) {
                this.active++;
            }
        },
        Previous() {
            // 上一步
            if (this.active < 1) {
                return;
            }
            this.active--;
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        deleteSku(row) {
            // 至少保留一个SKU？ ？
            if (this.tableData.length == 1) {
                this.$message({
                    message: " Keep at least one SKU",
                    type: "warning"
                });
                return;
            }
            this.$confirm("Determine the removal of the product?", {
                confirmButtonText: "Sure",
                cancelButtonText: "Cancel",
                type: "warning"
            })
                .then(() => {
                    this.tableData.splice(row.index, 1);
                })
                .catch(() => {
                    this.$message({
                        message: "Cancelled",
                        type: "info"
                    });
                });
        },
        // 增值服务选择 互斥
        gridchange(row) {

            if (row.spop_id == "38" && row.checked == true) {
                for (let i = 0; i < this.gridData.length; i++) {
                    if (this.gridData[i].spop_id == "39") {
                        this.gridData[i].checked = false;
                    }
                }
            } else if (row.spop_id == "39" && row.checked == true) {
                for (let i = 0; i < this.gridData.length; i++) {
                    if (this.gridData[i].spop_id == "38") {
                        this.gridData[i].checked = false;
                    }
                }
            }
        },
        // Skip() {
        //     this.active = 4;
        // },
        clickRow(row) {
            this.$refs.moviesTable.toggleRowSelection(row);
        },
        deletecarrier(item) {
            var index = this.twoform.carriers.indexOf(item);
            if (index !== -1) {
                this.$confirm('Determine to delete this express message?',{
                    confirmButtonText:'Sure',
                    cancelButtonText:'Cancel',
                    type:'warning'
                }).then(() => {
                    this.twoform.carriers.splice(index, 1);
                }).catch(() => {

                })
                
            }
        },
        delivery() {
            if (this.twoform.receivingWay != 2) {
                if (this.twoform.receivingWay == 3) {
                    this.onejs = true;
                } else {
                    this.onejs = false;
                }
                this.ofdelivery = false;
            } else {
                this.ofdelivery = true;
                this.onejs = false;
            }
        },
        addservices() {
            this.addserv = false;
            this.gridData = [];
            if (this.handleSelecti.length == 0) {
                this.$message.error("Please select the operation object");
            } else {
                this.dialogTableVisible = true;
                getspecial()
                    .then(response => {
                        if (response.data.ask == 1) {
                            for (let i = 0; i < response.data.data.data.length; i++) {
                                response.data.data.data[i].checked = false;
                                this.gridData.push(response.data.data.data[i]);
                            }
                            //response.data.data.data
                            //this.gridData = response.data.data.data;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        dialogRecharge() {
            
            let val = [];
            for (let i = 0; i < this.gridData.length; i++) {
                if (
                    this.gridData[i].checked != undefined &&
                    this.gridData[i].checked == true
                ) {
                    this.gridData[i].title = this.gridData[i].spop_desc;
                    val.push(this.gridData[i]);
                }
            }
            if(val.length===0){
                this.dialogTableVisible = false;
                return;
            }
            if (!this.addserv) {
                for (let i = 0; i < this.tableData3.length; i++) {
                    for (let j = 0; j < this.handleSelecti.length; j++) {
                        if (
                            this.tableData3[i].sku ==
                            this.handleSelecti[j].sku
                        ) {
                            this.tableData3[i].SPO_item = JSON.parse(
                                JSON.stringify(val)
                            );
                        }
                    }
                }
                this.dialogTableVisible = false;
            } else {
                for (let k = 0; k < this.tableData3.length; k++) {
                    if (this.tableData3[k].sku == this.nowSku) {
                        this.tableData3[k].SPO_item = JSON.parse(JSON.stringify(val));
                    }                    
                }
                this.dialogTableVisible = false;
            }
            
        },
        // 单个删除增值服务
        deleteSpo(arr,item){
            arr = arr.forEach((val, index) => {
                if(val.spop_id === item.spop_id){
                    arr.splice(index, 1);
                }
            });

        },
        addSPO(sku){
            this.addserv = true;
            this.nowSku = sku.row.sku;
            this.gridData = [];
            getspecial().then(response => {
                if (response.data.ask == 1) {
                    for (let i = 0; i < response.data.data.data.length; i++) {
                        response.data.data.data[i].checked = false;
                        this.gridData.push(response.data.data.data[i]);
                    }
                }
            })
            .catch(error => {
                console.log(error);
            });
            this.dialogTableVisible = true;
        },
        handleSelectionChange(val) {
            this.handleSelecti = val;
        },
        // 修改提交(str==='add' , 选择增值服务； str==='noAdd' 不选择增值服务)
        submitEdit(str){
            // 组装数据
            let params = {};
            let asn_sku = [];
            let SPO_item = [];

            if(this.twoform.receivingWay==='1'){
                params.deliver_way = 1
            }else{
                params.deliver_way = 2;
            }
            params.receiving_id = this.twoform.receivingId;
            params.asn_level = Number(this.twoform.asnLevel);
            params.reference_no = this.twoform.referenceNo;
            params.un_loading = Number(this.twoform.unLoading);
            params.tracking_number = this.twoform.carriers[0].trackingNumber;
            params.supplier = this.twoform.carriers[0].carrier
            // params.supplier = this.twoform.carriers[0].carrier;  将快递方式转为下标
            let _this = this;
            // this.carriername.forEach((item, index) => {
            //     if(item === _this.twoform.carriers[0].carrier){
            //         params.supplier = index;
            //     }
            // })
            params.contact = this.twoform.carriers[0].contactPerson;
            params.phone = this.twoform.carriers[0].contactNumber;
            params.preotd = this.twoform.carriers[0].estimatedDeliveryDate;

            this.tableData3.forEach(val => {
                let json = {
                    sku: val.sku,
                    quantity: val.quantity
                }
                asn_sku.push(json)
            })
            params.asn_sku = JSON.stringify(asn_sku);

            // 增值服务备注信息不能为空
            let canEdit = true;
            this.tableData3.forEach((val, index) => {
                if(val.SPO_item){
                    val.SPO_item.forEach(vals => {
                        if(vals.note){
                            let json = {
                                sku: val.sku,
                                note: vals.note,
                                spop_id: vals.spop_id
                            };
                            SPO_item.push(json)
                        }else{
                            canEdit = false;
                        }                  
                    })
                }
            })
            if(str==='add'){ // 选择了增值服务
                if(!canEdit){
                    this.$confirm('Please add notes for value-added services',{
                        confirmButtonText:'Sure',
                        type:'warning'
                    }).then(() =>{

                    }).catch(() => {

                    });
                    return
                }else{
                    if(SPO_item.length>0){
                        params.SPO_item = JSON.stringify(SPO_item);
                    }              
                    createasn(params).then(response => {
                        if(response.data.ask===1){
                            this.active = 4;
                        }
                    })
                }
            }else if(str==='noAdd'){ // 如果之前是有增值服务，择需提示用户是否放弃增值服务
                if(this.add_service){
                    this.$confirm('Determine to abandon value-added services?',{
                        confirmButtonText:'Sure',
                        cancelButtonText:'Cancel',
                        type:'warning'
                    }).then(() => {
                        createasn(params).then(response => {
                            if(response.data.ask===1){
                                this.active = 4;
                            }
                        }).catch(error => {
                            console.log(error);
                        })
                    })
                }else{
                    createasn(params).then(response => {
                        if(response.data.ask===1){
                            this.active = 4;
                        }
                    }).catch(error => {
                        console.log(error)
                    })
                }
            }
        }
    }
};
</script>
<style>
a {
    color: #8989ba;
    cursor: pointer;
}
.demo-table-expand {
    font-size: 0;
}
.demo-table-expand label {
    width: 200px;
    color: #99a9bf;
}
.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
}
.stepsTab {
    padding: 20px;
    margin: 20px;
    text-align: left;
    position: relative;
}

.delBtn {
    font-size: 18px;
    cursor: pointer;
}
.delBtn:hover {
    color: #f00;
}
.expand .el-table__expand-column .cell {
    display: none;
}
</style>




// WEBPACK FOOTER //
// src/components/views/AsnOrder/Ansdetails/Ansedit.vue